<script>
import i18nValidate from "@/i18ns/vi/i18nValidate";
import { MsControlRef } from "@/models/enums/MsControlRefConst.js";
export default {
  name: "MsBaseComponent",
  props: {
    readonly: {
      default: false,
      type: Boolean,
    },
    /** rule dùng để validate control
     *  ex: "required | number"
     *  Created by LTDAT(22.06.2020)
     */
    rules: {
      type: String,
      default: null,
    },
    /**
     * Tên của control phục vụ việc hiện thị message cho validate
     * Created by LTDAT(22.06.2020)
     */
    name: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      errorProvider: {},
      controlRef: "",
      controlFocusRef:'',
      title: "", // @ data to override - title để hiển thị message validate
      isComponentValidate: true,
      errorElement: null
    };
  },
  created() {
    const me = this;
  },
  methods: {
    /**
     * Validate component sự kiện validate control
     * Created by LTDAT(22.06.2020)
     *  */
    validate() {
      const me = this;
      me.errorElement = me.getErrorElement()
      if (me.disabled) {
        return {};
      }
      let listRules = [],
        ret = false;
      if (me.rules) {
        listRules = me.rules.split("|");
      }
      for (let i = 0; i < listRules.length; i++) {
        ret = !me.validateRule(listRules[i], me.internalText);
        if (ret) {
          me.$set(me.errorProvider,'message',i18nValidate.messages[listRules[i]](me.name))
          me.errorProvider.rules = listRules[i];
          me.$set(me.errorProvider, "isValid", true);
          me.errorProvider.element = me;
          return me.errorProvider;
        } else {
          me.errorProvider = {}
        }
      }
      return {}    
    },


    /**
     * @abstract
     * @author THNhat 
     * @since 23/3/2022
     * @description focus khi validate có lỗi
     * @returns 
     */
    focusError(){
      
    },

    validateRule(rule, value) {
      const me = this;
      switch (rule) {
        case "required":
          return me.validateRequired(value);
          break;
        case "noSpace":
          return me.validateNoSpace(value);
          break;
        case "formula":
          return me.validateFormula(value);
          break;
        case "alpha_dash_v2":
          return me.validateSalaryCode(value);
          break;
        case "phoneEmail":
          if (value) {
            return me.validatePhoneEmail(value);
          } else {
            return true;
          }
          break;
        case "phone":
          if (value) {
            return me.validatePhone(value);
          } else {
            return true;
          }
          break;
        case "email":
          if (value) {
            return me.validateEmail(value);
          } else {
            return true;
          }
          break;
        case "password":
          return me.validatePassword(value);
          break;
        case "mark":
          return me.validateMark(value);
          break;
        case "checkBiggerToday":
          return me.validateBiggerToday(value);
          break;
        case "default":
          return me.validateCustom(value);
          break;
      }
    },


    /**
     * @abstract
     * @author THNhat 
     * @since 23/3/2022
     * @description custom rule validate rieeng của input
     * @returns 
     */
    validateCustom(value){

    },

    /**
     * Validate ghi điểm
     * Created By DXDUNG - 21/10/2020
     */
    validateMark(value) {
      var value_parse = parseFloat(value);
      var checkInt = this.isInt(value_parse);
      var checkFloat = this.isFloat(value_parse);

      if ((checkInt || checkFloat) && value_parse >= 0 && value_parse <= 10) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * check int
     * Created By DXDUNG - 22/10/2020
     */
    isInt(n) {
      return Number(n) === n && n % 1 === 0;
    },

    /**
     * check float
     * Created By DXDUNG - 22/10/2020
     */
    isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    },

    /**
     * @abstract
     * @author THNhat 
     * @since 22/3/2022
     * @description Check validate required
     * @returns false: error, true: correct
     */
    validateRequired(value) {
      if (!value && value !== 0 && value !== "0") value = "";
      if (!value.toString().trim()) {
        return false;
      }
      return true;
    },
    /**
     * check có khoảng trắng
     */
    validateNoSpace(val) {
      var regex = /\s/g;
      return !regex.test(val);
    },
    /**
     * Check công thức
     */
    validateFormula(val) {
      const listFormula = ["SUM", "IF", "AND", "OR", "ROUND", "DATE", "INT"];
      let lstValue =
        val &&
        val
          .toString()
          .toUpperCase()
          .match(/[a-zA-Z]+[(]/gi);
      let isValid = true;
      lstValue &&
        lstValue.length &&
        lstValue.forEach((element) => {
          if (!listFormula.contains(element.replace("(", ""))) {
            isValid = false;
          }
        });
      return isValid;
    },
    /**
     * Check ký tự đặc biệt;
     */
    validateSalaryCode(val) {
      var regex = /^[a-zA-Z0-9_]+$/;
      return regex.test(val);
    },
    //Validate mã số thuế
    validateTaxCode(value) {
      try {
        var oRegex = /^[0-9]{10}$|^[0-9]{13}$|^[0-9]{10}(\s|-)[0-9]{3}$/;
        if (oRegex.test(value)) {
          var arrcode = [],
            lengthCode = value.length;
          for (var i = 0; i < lengthCode; i++) {
            arrcode.push(value[i]);
          }

          var intTemp =
            31 * parseFloat(arrcode[0]) +
            29 * parseFloat(arrcode[1]) +
            23 * parseFloat(arrcode[2]) +
            19 * parseFloat(arrcode[3]) +
            17 * parseFloat(arrcode[4]) +
            13 * parseFloat(arrcode[5]) +
            7 * parseFloat(arrcode[6]) +
            5 * parseFloat(arrcode[7]) +
            3 * parseFloat(arrcode[8]);

          if (!(parseFloat(arrcode[9]) === 10 - (intTemp % 11))) {
            return false;
          }
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    validatePhoneEmail(value) {
      try {
        return this.validatePhone(value) || this.validateEmail(value);
      } catch (e) {
        return false;
      }
    },
    validatePhone(value) {
      try {
        var oRegex =
          /^(0|\+84)(\s|\.)?((3[2-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/;
        var result = value;
        if (!oRegex.test(result.trim())) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    validateEmail(value) {
      try {
        var oRegex =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var result = value;
        if (!oRegex.test(result.trim())) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    validatePassword(value) {
      const me = this;
      let lengthPass = false;
      if (value && value.length >= 8) {
        lengthPass = true;
      }
      let textPass = false;
      let upcasePass = false;
      let lowercasePass = false;
      if (value && /[^A-Z]/g.test(value)) {
        upcasePass = true;
      }
      if (value && /[^a-z]/g.test(value)) {
        lowercasePass = true;
      }
      if (upcasePass && lowercasePass) {
        textPass = true;
      }
      let numberPass = false;
      if (value && /[^0-9]/g.test(value)) {
        numberPass = true;
      }
      me.$set(me.errorProvider, "lengthPass", lengthPass);
      me.$set(me.errorProvider, "textPass", textPass);
      me.$set(me.errorProvider, "numberPass", numberPass);
      return lengthPass && textPass && numberPass;
    },

    applyValidate(message) {
      const me = this;
      if (message) {
        me.$set(me.errorProvider, "message", message);
        me.$set(me.errorProvider, "isValid", true);
        me.errorProvider.element = me;
      } else {
        me.errorProvider = {};
      }
    },

    /**
     * validate nhỏ hơn ngày hiện tại
     */
    validateBiggerToday(value) {
      let date = new Date(value).setHours(0, 0, 0, 0);
      let dateNow = new Date().setHours(0, 0, 0, 0);
      return date > dateNow ? false : true;
    },

    /**
     * @abstract
     * @author THNhat 
     * @since 22/3/2022
     * @description
     * @returns 
     */
    getErrorElement(){
      const me = this
      let errorScrollElement = me.$refs[me.controlRef] ? me.$refs[me.controlRef] : null;
      let errorFocusElement = me.$refs[me.controlFocusRef] ? me.$refs[me.controlFocusRef] : null;
      return {errorScrollElement : errorScrollElement,errorFocusElement : errorFocusElement}
    }
  }
};
</script>
<style lang="scss" scoped>
</style>

